// extracted by mini-css-extract-plugin
export default {"container":"bk_b","title":"bk_cP","socialIcons":"bk_cL"};